/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lg-container[_ngcontent-%COMP%]{padding:1rem;display:grid;align-items:stretch}.reverse[_ngcontent-%COMP%]{margin:0 20px;border-top:1px solid rgba(120,130,140,.13);padding-left:0}.reverse[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#373a3c}"];
export { styles as styles };
